import { Cookies } from 'react-cookie';

import { IDigestReportResponse } from './type';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface DigestReportDataProps {
  slug: string;
}
export interface DigestReportData {
  id: number;
  datetime: string;
  created_by: {
    image: string;
    slug: string;
    username: string;
  };
  site: number;
  status: string;
}
export const getDigestReports = async ({ slug }: DigestReportDataProps): Promise<IDigestReportResponse[]> => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const response = await axiosInterceptor.get<IDigestReportResponse[]>(`/objects/${slug}/technician-digests/`, {
    headers: {
      Authorization: token,
    },
  });

  return response.data;
};
